import styled, { css } from 'styled-components';

export default styled.div`
  ${() => {
    return css`
      overflow-y: auto;
      height: 100%;
      margin-bottom: 1em;
      .block-panel__loading {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
      ul {
        list-style: none;
        padding: 0 1em;
        margin: 0;
        height: 28em;
      }
      ul li {
        &:not(:last-child) {
          margin-bottom: 0.5em;
        }
      }
    `;
  }}
`;
